export const modalText = {
  callToComplete: "Call Us to Complete Enrollment",
  thankYou: ". Thank you.",
  phoneNumber: "1-800-825-5687",
  medicarePhoneNumber: "1-800-324-3899",
  talkMVPPhoneNumber: '1-800-TALK-MVP',
  over65: {
    part1: "If you are 65 or older, for information on how to enroll in Medicare through MVP, please call ",
  },
  under19: {
    part1: "If you or your spouse are under the age of 19 then your application will require manual processing.",
    part2: " For enrollment assistance please contact ",
  },
  submissionError: {
    title: 'Error: Unable to Submit',
    unableToSubmit: 'We were unable to submit your application at this time. Please try again.'
  },
  planNotFound: {
    title: 'Unable to Find Your Plan',
    descriptionBeginning: 'We are unable to pull the plan you had selected. Please return to the',
    descriptionEnding: 'page to begin your online enrollment.',
    linkText: 'Plan Shopping'
  },
  continue: {
    beginning: 'If you continue to get this message please call',
    ending: 'to finish enrolling'
  },
  between26and29: {
    part1: "Enrolling dependents between the ages of 26 and 29 will require manual processing (a plan rider will need to be purchased). For enrollment assistance please contact ",
  },
  thirtyAndOlder: {
    part1: "Enrolling dependents 30 years and older requires their own individual plan. For enrollment assistance, please contact ",
  },
  effectiveDateError: {
    title: 'Call Us to Complete Enrollment',
    part1: 'We are unable to process your online enrollment at this time due to questions on your effective date. Please call ',
    phoneNumber: '1-800-TALK-MVP',
    part2: ' and a representative will be happy to assist with your enrollment.',
  },
  cannotRetrieveBenefitsSummary: {
    title: 'Unable to Retrieve Benefits Summary PDF',
    descriptionBeginning: 'The Benefits Summary PDF for your selected plan could not be retrieved. Please return to the',
    descriptionEnding: 'page to re-submit your enrollment.',
    linkText: 'Plan Shopping'
  },
}